import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

import { containsNetworkError } from '@confluence/network';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError';

export function isExpectedError(error: ApolloErrorInterop) {
	const isUnauthorized =
		error?.graphQLErrors?.[0]?.message === 'unauthorized' || isUnauthorizedError(error);

	return isUnauthorized || containsNetworkError(error);
}
